module.exports = {
	garamond: 'garamond-premier-pro, serif',
	objektiv: 'objektiv-mk1, sans-serif',
	weights: {
		light: '300',
		regular: '400',
		medium: '500',
	},
};
